import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { AssetSelectedTypeMap } from '../../../../../../../../../store/product/types';

import { CoesItemSelectedDesktop } from './desktop';
import { CoesItemSelectedMobile } from './mobile';
import { CoesItemSelectedTablet } from './tablet';

export namespace CoesItemSelectedTypes {
  export interface Props {
    offer: AssetSelectedTypeMap['coes'];
    onUpdate: (offerUpdated: AssetSelectedTypeMap['coes']) => void;
    hideLateralBar?: boolean;
  }
}

export const CoesItemSelected: React.FC<CoesItemSelectedTypes.Props> = (props) => {
  const coesSelectedItem = useBreakpointValue({
    base: <CoesItemSelectedMobile {...props} />,
    sm: <CoesItemSelectedTablet {...props} />,
    lg: <CoesItemSelectedDesktop {...props} />,
  });

  return coesSelectedItem;
};
